import { AuthPage } from "../auth";

export const Register = () => {
  return <AuthPage type="register" />;
};
